import { render, staticRenderFns } from "./modal-batch-role-group.vue?vue&type=template&id=bb89a312&"
import script from "./modal-batch-role-group.vue?vue&type=script&lang=js&"
export * from "./modal-batch-role-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports